<template>
  <div v-if="getQuoteSingle">
    <appQuoteViewCom
      :propsData="getQuoteSingle"
      :quoteType="'quote'"
      @callSingleQuote="fnCallSingleQuote()"
    ></appQuoteViewCom>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import appQuoteViewCom from '../../../components/quote/quoteViewCom.vue'
export default {
  name: 'quoteView',
  components: {
    appQuoteViewCom
  },
  data() {
    return {
      quoteId: this.$route.params.quoteId
    }
  },
  computed: {
    ...mapGetters(['getQuoteSingle'])
  },
  methods: {
    ...mapActions(['fetchQuoteSingle']),
    fnCallSingleQuote: async function () {
      await this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: 'quote'
      })
    }
  },
  async created() {
    await this.fetchQuoteSingle({
      id: this.quoteId,
      quoteType: 'quote'
    })
  }
}
</script>
